/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import { useNavigate, useLocation, useSearchParams, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect, useContext } from 'react';
import Keyboard from 'react-simple-keyboard';
import { useFocusTrap } from '@mantine/hooks';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  ActionIcon,
  Modal,
  Textarea,
  Text,
  Group,
  Input,
  Select,
  Divider,
  List,
  Space,
  Grid,
  Table,
  ScrollArea,
  SimpleGrid,
  Image,
  TextInput,
  Card,
  Container,
  Paper,
  Loader,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import carWash from '../../image/car-wash.svg';
import trolley from '../../image/trolley.svg';
import backButton from '../../image/backArrow.png';
import home from '../../image/home.svg';
import QR from '../../image/qr.png';
import CarArrow from '../../image/car-arrow.png';
import AlertImg from '../../image/alert.svg';
import CarArrowReverse from '../../image/carArrow-reverse.png';
import './TicketNumber.css';
import PrimaryButton from '../../components/GroupButton';
import AppContext from '../../components/Context/index';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import PaymentStatus from '../PosPayment/PaymentStatus';

const UserDetails = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const passIdData = searchParams.get('passId');
  const [mounted, setMounted] = useState(false);
  const [location, setLocation] = useState('');
  const focusTrapRef = useFocusTrap();
  const [ticketNumber, setTicketNumber] = useState();
  const VarsPrice = searchParams.get('vasTypesPrice');
  const vasQty = searchParams.get('vas_qty');
  const vasId = searchParams.get('vasTypeId');
  const vasType = searchParams.get('vasName');
  const carWashInside = searchParams.get('carWashValue1');
  const carWashOutside = searchParams.get('carWashValue2');
  const carWashBoth = searchParams.get('carWashValue3');
  const Price = searchParams.get('sitePrice');
  const userName = searchParams.get('name');
  const Mobile = searchParams.get('mobile');
  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);
  const [ticketData, setTicketData] = useState();

  const selectedVas = JSON.parse(localStorage.getItem('selectedVas'));

  // Vas Calculation frontend //
  const vasDataTotalUnpaid = !selectedVas
    ? 0
    : selectedVas[0]?.vas_Name === 'Trolley'
    ? ticketData?.invoices?.tax +
        Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
        ticketData?.invoices?.total_amount +
        Number(selectedVas[1]?.vas_Price) ||
      Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
        ticketData?.invoices?.total_amount +
        ticketData?.invoices?.tax
    : selectedVas[0]?.vas_Name === 'Car Wash'
    ? ticketData?.invoices?.tax +
        Number(
          Number(selectedVas[0]?.vas_Price) +
            ticketData?.invoices?.total_amount +
            Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
        ) ||
      Number(selectedVas[0]?.vas_Price) +
        ticketData?.invoices?.tax +
        ticketData?.invoices?.total_amount
    : ticketData?.invoices?.tax +
      Number(
        Number(selectedVas[0]?.vas_Price) +
          Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
      );

  const vasDataTotalPaid = !selectedVas
    ? 0
    : selectedVas[0]?.vas_Name === 'Trolley'
    ? ticketData?.invoices?.tax +
        Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
        Number(selectedVas[1]?.vas_Price) ||
      Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) + ticketData?.invoices?.tax
    : selectedVas[0]?.vas_Name === 'Car Wash'
    ? ticketData?.invoices?.tax +
        Number(
          Number(selectedVas[0]?.vas_Price) +
            Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
        ) || Number(selectedVas[0]?.vas_Price) + ticketData?.invoices?.tax
    : ticketData?.invoices?.tax +
      Number(
        Number(selectedVas[0]?.vas_Price) +
          Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
      );

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
    console.log('Array', selectedVas);
  }, []);

  const [input, setInput] = useState('');
  const [total, setTotal] = useState();
  useEffect(() => {
    // fetch(`https://sp.api.v2.hyperthings.in/api/v1/parking/reservations-by-pass-id/${passIdData}`, {
    //   method: 'GET',
    //   headers: { android_id: 'test' },
    // })
    sendRequest(`parking/reservations-by-pass-id/${passIdData}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data?.result || []);
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
    // .then((res) => res.json())
    // .then((response) => {
    //   setTicketData(response?.data?.result);
    // });
    console.log('mk', ticketData);
  }, [passIdData]);

  const searchTicket = () => {
    sendRequest(`parking/reservations-by-pass-id/${passIdData}`, 'get').then((res) => {
      setTicketData(res?.data?.result || []);
    });
  };

  const onPayment = async () => {
    fetch('http://192.168.0.186:9001/payments', {
      method: 'POST',
      headers: {
        android_id: 'test',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        reservation_id: parseInt(ticketData?.id, 10),
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response?.code === 20) {
          navigate({
            pathname: '/payment',
            search: createSearchParams({
              passId: parseInt(ticketData?.id, 10),
              checkoutId: response?.data?.id,
            }).toString(),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const posPaymentObject = {
  //   MSGID: 'PUR',
  //   ECRNo: '001',
  //   RecieptNo: passIdData,
  //   Amount: '2.00 SAR',
  // };

  // console.log('DataPOS', posPaymentObject);

  const posPayment = () => {
    navigate({
      pathname: '/insertcard',
      search: createSearchParams({
        passId: passIdData,
      }).toString(),
    });
  };

  const detailsPage = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        numberplate: ticketData?.vehicles?.number_plate,
        tax: ticketData?.invoices?.tax,
        passId: passIdData,
      }).toString(),
    });
  };
  const now = dayjs();

  const date1 = dayjs(ticketData?.start_time);
  const date2 = dayjs(!ticketData?.end_time ? now : ticketData?.end_time);
  // const diff = date2.diff(date1, 'day', true);
  // console.log('obtained', diff);
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  // const days = Math.floor(diff);
  // const hours = Math.floor((diff - days) * 24);
  // console.log(`${days} days, ${hours} hours`);

  // const { t, i18n } = useTranslation();

  // const [language, setLanguage] = useState();
  // i18n.changeLanguage(language);

  // const changeLanguageHandler = (e) => {
  //   const languageValue = e.target.value;
  //   i18n.changeLanguage(languageValue);
  // };

  const startDate = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(!ticketData?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(!ticketData?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const [response, setResponse] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [cashData, setCashData] = useState();

  const cardPayment = () => {
    if (ticketData?.invoices?.invoice_status?.name === 'paid' && !selectedVas) {
      setCardPay(true);
    }
    const wsurl = `ws://localhost:5000/messages`;

    // Init Websocket Client
    const client = new W3CWebSocket(wsurl);
    client.onerror = () => {
      console.log('Connection Error');
      if (ticketData?.invoices?.invoice_status?.name === 'paid') {
        setCardPay(true);
      } else {
        setErrorPos(true);
      }
    };

    client.onopen = () => {
      console.log('WebSocket Client Connected');

      function connectPort() {
        if (client.readyState === client.OPEN) {
          const comName = 'COM8';
          const sendData = JSON.stringify({
            Event: 'CONNECTION',
            Operation: 'CONNECT',
            connectionMode: 'COM',
            comName,
            braudRate: '38400',
            dataBits: '8',
            parity: 'none',
          });

          client.send(sendData);
        }
      }

      connectPort();

      function sendAmount() {
        if (client.readyState === client.OPEN) {
          const amount =
            ticketData?.invoices?.invoice_status?.name !== 'paid' && !selectedVas
              ? ticketData?.invoices?.payable_amount
              : ticketData?.invoices?.invoice_status?.name === 'paid'
              ? vasDataTotalPaid
              : vasDataTotalUnpaid;
          const sendAmountData = JSON.stringify({
            Event: 'TRANSACTION',
            Operation: 'PURCHASE',
            Amount: amount,
            PrintSettings: '1',
            AppId: '11',
            ECRNumber: '1234567890123456',
          });
          client.send(sendAmountData);
        }
      }
      sendAmount();
    };

    client.onclose = () => {
      console.log('echo-protocol Client Closed');
    };

    client.onmessage = (message) => {
      if (typeof message.data === 'string') {
        // console.log('Received', message.data);
        setResponse(JSON.parse(message?.data));
      }
    };
  };
  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    }
  });

  useEffect(() => {
    if (response?.EventName === 'TERMINAL_RESPONSE') {
      const body = {
        reservation_id: parseInt(ticketData?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequestWithToken(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            setCardPay(true);
            searchTicket();
            console.log('payment-status', paymentStatus);
            console.log('push-resID&transactionId to backend', body, data);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err?.response?.data?.code) {
            console.log('err', err?.response?.data?.code);
          }
        });
    }
  }, [paymentStatus?.RetrievalReferenceNumber, ticketData?.id]);

  // console.log(
  //   'dataTotal',
  //   ticketData?.invoices?.invoice_status?.name !== 'paid' && !selectedVas
  //     ? ticketData?.invoices?.payable_amount
  //     : ticketData?.invoices?.invoice_status?.name === 'paid'
  //     ? vasDataTotalPaid
  //     : vasDataTotalUnpaid,
  // );

  return (
    <Box>
      <Center className="no-printme">
        {!ticketData?.id ? (
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('enter.ticket.number')}
          </Title>
        ) : (
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('enter.ticket.summary')}
          </Title>
        )}
      </Center>
      <Space h="xs" />
      <Center className="no-printme">
        <Stack>
          {!ticketData?.id && ticketNumber ? (
            <Center>
              <Title order={3}>{t('enter.invalid.ticket.number')}</Title>
            </Center>
          ) : null}
          {ticketData?.id ? (
            <Box>
              <Paper shadow="lg" withBorder p="xs">
                <Stack>
                  <Group position="apart">
                    <Text size="sm" weight={500} color="#817E7E">
                      {t('ticket.welcome')} {!userName ? t('ticket.guest') : userName}
                    </Text>

                    {ticketData?.invoices?.invoice_status?.id === '2' ? (
                      <Text size="xl" weight={700} color="green">
                        {t('status.paid')}
                      </Text>
                    ) : null}

                    <Text size="sm" weight={500} color="#817E7E">
                      {t('ticket.plate.number')}: {ticketData?.vehicles?.number_plate}
                    </Text>
                  </Group>
                  <Group position="apart" style={{ marginBottom: '-20px' }}>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            {t('ticket.entry.text')}
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {startDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {startTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                    {appState?.language === 'ar' ? (
                      <Image src={CarArrowReverse} />
                    ) : (
                      <Image src={CarArrow} />
                    )}
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            {t('ticket.exit.text')}
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {endDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {endTime}
                          </Text>
                        </Center>
                      </Stack>
                      <ActionIcon
                        color="dark"
                        size="xl"
                        radius="xl"
                        variant="default"
                        sx={{
                          borderColor: 'black',
                          width: '80px',
                          height: '80px',
                          borderRadius: '50px',
                        }}
                      >
                        <Text weight={900} size="lg">
                          {hours} {t('ticket.hours.text')}
                        </Text>
                      </ActionIcon>
                    </Group>
                  </Group>
                  <Group position="apart" spacing="xl">
                    <Stack style={{ marginTop: '15px' }}>
                      <Title size="sm" order={2}>
                        {t('ticket.description.text')}
                      </Title>
                      <Text size="sm" weight={500} color="#817E7E">
                        {hours} {t('ticket.hours.parking.text')}
                      </Text>
                      {ticketData?.vas_orders.map((item) => (
                        // <Text size="sm" weight={500} color="#817E7E">
                        //   {item?.vas_types?.name}
                        // </Text>
                        <div>
                          {appState?.language === 'en' ? (
                            <Text weight={500}>{item.vas_types?.name}</Text>
                          ) : (
                            <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                              {item.vas_types?.name === 'Trolley' ? (
                                <Text weight={500}>{t('choose.service.trolly.title.text')}</Text>
                              ) : item.vas_types?.name === 'Car Wash' ? (
                                <Text weight={500}>{t('choose.service.carwash.title.text')}</Text>
                              ) : (
                                <Text weight={500}>{t('choose.service.shuttle.title.text')}</Text>
                              )}
                            </Group>
                          )}
                        </div>
                      ))}

                      {selectedVas ? (
                        <>
                          {selectedVas.map((item) => (
                            <Group>
                              {/* <Text size="sm" weight={500} color="#817E7E">
                                {item?.vas_Name}
                              </Text> */}
                              {appState?.language === 'en' ? (
                                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                                  <Text weight={500}>{item.vas_Name}</Text>
                                </Group>
                              ) : (
                                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                                  {item.vas_Name === 'Trolley' ? (
                                    <Text weight={500}>
                                      {t('choose.service.trolly.title.text')}
                                    </Text>
                                  ) : (
                                    <Text weight={500}>
                                      {t('choose.service.carwash.title.text')}
                                    </Text>
                                  )}
                                </Group>
                              )}
                              {item?.vas_Id === 2 ? (
                                <Text size="sm" weight={400} color="#817E7E">
                                  X {item?.vas_qty}
                                </Text>
                              ) : item?.vas_Id === 3 ? (
                                <Text size="sm" weight={400} color="#817E7E">
                                  X {item?.vas_qty}
                                </Text>
                              ) : item?.vas_Id === 24 ? (
                                <Text size="sm" weight={400} color="#817E7E">
                                  <Group>
                                    {item?.carWashValueone === true ? (
                                      <Text size="sm" weight={400} color="#817E7E">
                                        {t('choose.service.carwash.inside.text')}
                                      </Text>
                                    ) : null}
                                    {item?.carWashValuetwo === true ? (
                                      <Text size="sm" weight={400} color="#817E7E">
                                        {t('choose.service.carwash.outside.text')}
                                      </Text>
                                    ) : null}
                                    {item?.carWashValuethree === true ? (
                                      <Text size="sm" weight={400} color="#817E7E">
                                        {t('choose.service.carwash.both.text')}
                                      </Text>
                                    ) : null}
                                  </Group>
                                </Text>
                              ) : null}
                            </Group>
                          ))}
                        </>
                      ) : null}

                      {/* {vasType !== null ? (
                        <Group>
                          {vasId !== '24' ? (
                            <Text size="sm" weight={400} color="#817E7E">
                              X {vasQty}
                            </Text>
                          ) : vasId !== '2' || '3' ? (
                            <Text size="sm" weight={400} color="#817E7E">
                              <Group>
                                {carWashInside === 'true' ? (
                                  <Text size="sm" weight={400} color="#817E7E">
                                    Inside ,
                                  </Text>
                                ) : null}
                                {carWashOutside === 'true' ? (
                                  <Text size="sm" weight={400} color="#817E7E">
                                    Outside ,
                                  </Text>
                                ) : null}
                                <Group></Group>
                                {carWashBoth === 'true' ? (
                                  <Text size="sm" weight={400} color="#817E7E">
                                    Both ,
                                  </Text>
                                ) : null}
                              </Group>
                            </Text>
                          ) : null}
                        </Group>
                      ) : null} */}

                      {/* <Text size="sm" weight={500} color="#817E7E">
                        {t('ticket.tax.text')}
                      </Text> */}
                    </Stack>

                    <Stack>
                      <Title size="sm" order={2}>
                        {t('ticket.amount.text')}
                      </Title>
                      <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : (Number(ticketData?.amount) * hours).toFixed(2)}{' '}
                        {t('ticket.amount.sar.text')}
                      </Text>
                      {ticketData?.vas_orders.map((item) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.invoices?.invoice_status?.name === 'paid'
                            ? 0
                            : Number(item?.amount) * Number(item?.qty)}{' '}
                          {t('ticket.amount.sar.text')}
                        </Text>
                      ))}
                      {/* {vasType !== null ? (
                        <Text size="sm" weight={500} color="#817E7E">
                          {VarsPrice} SAR
                        </Text>
                      ) : null} */}
                      {selectedVas ? (
                        <>
                          {selectedVas.map((item) => (
                            <div>
                              {item?.vas_Name === 'Trolley' ? (
                                <Text size="sm" weight={500} color="#817E7E">
                                  {Number(item?.vas_Price) * Number(item?.vas_qty)}{' '}
                                  {t('ticket.amount.sar.text')}
                                </Text>
                              ) : item?.vas_Name === 'Car Wash' ? (
                                <Text size="sm" weight={500} color="#817E7E">
                                  {item?.carWashValueone === true &&
                                  item?.carWashValuetwo === false ? (
                                    <>
                                      {Number(item?.vas_Price)} {t('ticket.amount.sar.text')}
                                    </>
                                  ) : item?.carWashValuetwo === true &&
                                    item?.carWashValueone === false ? (
                                    <>
                                      {Number(item?.vas_Price)} {t('ticket.amount.sar.text')}
                                    </>
                                  ) : item?.carWashValuethree === true ? (
                                    <>
                                      {Number(item?.vas_Price)} {t('ticket.amount.sar.text')}
                                    </>
                                  ) : item?.carWashValueone === true ||
                                    item?.carWashValuetwo === true ? (
                                    <>
                                      {Number(item?.vas_Price) + Number(item?.vas_Price)}{' '}
                                      {t('ticket.amount.sar.text')}
                                    </>
                                  ) : null}
                                </Text>
                              ) : null}
                            </div>
                          ))}
                        </>
                      ) : null}
                      {/* <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.invoices?.invoice_status?.name === 'paid' && !VarsPrice
                          ? 0
                          : ticketData?.invoices?.tax}{' '}
                        {t('ticket.amount.sar.text')}
                      </Text> */}
                    </Stack>
                  </Group>
                  <Divider size="sm" />
                  <Group position="apart">
                    <Stack>
                      <Text size="sm" weight={500} color="#817E7E">
                        {t('ticket.tax.text')}
                      </Text>
                      <Title size="sm" order={2}>
                        {t('ticket.amount.total.text')}
                      </Title>
                    </Stack>

                    {selectedVas ? (
                      <Stack px="xl">
                        {ticketData?.invoices?.invoice_status?.name === 'paid' ? (
                          <Title size="sm" order={2} px="xs">
                            {ticketData?.invoices?.invoice_status?.name === 'paid' && !selectedVas
                              ? 0
                              : selectedVas[0]?.vas_Name === 'Trolley'
                              ? ticketData?.invoices?.tax +
                                  Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
                                  Number(selectedVas[1]?.vas_Price) ||
                                Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
                                  ticketData?.invoices?.tax
                              : selectedVas[0]?.vas_Name === 'Car Wash'
                              ? ticketData?.invoices?.tax +
                                  Number(
                                    Number(selectedVas[0]?.vas_Price) +
                                      Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
                                  ) || Number(selectedVas[0]?.vas_Price) + ticketData?.invoices?.tax
                              : ticketData?.invoices?.tax +
                                Number(
                                  Number(selectedVas[0]?.vas_Price) +
                                    Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
                                )}{' '}
                            {t('ticket.amount.sar.text')}
                          </Title>
                        ) : (
                          <Title size="sm" order={2} px="xs">
                            {ticketData?.invoices?.invoice_status?.name === 'pending' &&
                            !selectedVas
                              ? 0
                              : selectedVas[0]?.vas_Name === 'Trolley'
                              ? ticketData?.invoices?.tax +
                                  Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
                                  ticketData?.invoices?.total_amount +
                                  Number(selectedVas[1]?.vas_Price) ||
                                Number(selectedVas[0]?.vas_Price * selectedVas[0]?.vas_qty) +
                                  ticketData?.invoices?.total_amount +
                                  ticketData?.invoices?.tax
                              : selectedVas[0]?.vas_Name === 'Car Wash'
                              ? ticketData?.invoices?.tax +
                                  Number(
                                    Number(selectedVas[0]?.vas_Price) +
                                      ticketData?.invoices?.total_amount +
                                      Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
                                  ) ||
                                Number(selectedVas[0]?.vas_Price) +
                                  ticketData?.invoices?.tax +
                                  ticketData?.invoices?.total_amount
                              : ticketData?.invoices?.tax +
                                Number(
                                  Number(selectedVas[0]?.vas_Price) +
                                    Number(selectedVas[1]?.vas_Price) * selectedVas[1]?.vas_qty,
                                )}{' '}
                            {t('ticket.amount.sar.text')}
                          </Title>
                        )}
                      </Stack>
                    ) : (
                      <Stack px="xl">
                        <Text size="sm" weight={500} color="#817E7E" style={{ marginLeft: '65px' }}>
                          {ticketData?.invoices?.invoice_status?.name === 'paid' && !VarsPrice
                            ? 0
                            : ticketData?.invoices?.tax}{' '}
                          {t('ticket.amount.sar.text')}
                        </Text>
                        <Title size="sm" order={2} px="xs">
                          {ticketData?.invoices?.invoice_status?.name === 'paid' && !Price
                            ? 0
                            : ticketData?.invoices?.payable_amount}{' '}
                          {t('ticket.amount.sar.text')}
                        </Title>
                      </Stack>
                    )}
                  </Group>

                  <Group position="apart">
                    <SimpleGrid cols={2} sx={{ width: '100%' }}>
                      {ticketData?.invoices?.invoice_status?.name === 'paid' ||
                      (ticketData?.tickets?.ticket_status_types?.name === 'Out' && !selectedVas) ? (
                        <Button
                          // onClick={posPayment}
                          onClick={cardPayment}
                          sx={{ backgroundColor: '#01AA84', width: '100%' }}
                          size="xl"
                          // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
                        >
                          {t('payment.status.invoice.print.invoice.button.text')}
                        </Button>
                      ) : (
                        <Button
                          // onClick={posPayment}
                          onClick={cardPayment}
                          sx={{ backgroundColor: '#01AA84', width: '100%' }}
                          size="xl"
                          // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
                        >
                          {t('ticket.amount.pay.button.text')}
                        </Button>
                      )}
                      <Button
                        onClick={detailsPage}
                        sx={{ backgroundColor: '#34B3F1', width: '100%' }}
                        size="xl"
                      >
                        {t('ticket.amount.other.service.button.text')}
                      </Button>
                    </SimpleGrid>
                  </Group>
                </Stack>
              </Paper>
            </Box>
          ) : null}
        </Stack>
      </Center>
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space h="xs" />

      {!ticketData?.id ? (
        <>
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="md" />
        </>
      ) : null}

      <PrimaryButton />
      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
      <Modal
        opened={cardPay}
        onClose={() => setCardPay(false)}
        centered
        size="90%"
        // title={<Text p="xl">You want to end the shift</Text>}
      >
        <Center>
          {paymentStatus?.TransactionResponseEnglish === 'APPROVED' ||
          (ticketData?.invoices?.invoice_status?.name === 'paid' && !selectedVas) ? (
            <PaymentStatus
              invoiceDataId={ticketData?.invoices?.id}
              passDataId={passIdData === undefined ? input : passIdData}
            />
          ) : (
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {response?.TerminalStatus === 'BUSY' ? (
                        <Stack>
                          <Title order={1}>Payment Processing</Title>
                          <Loader variant="dots" />
                        </Stack>
                      ) : paymentStatus?.TransactionResponseEnglish === 'DECLINED' ? (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </Center>
          )}
        </Center>
      </Modal>
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
    </Box>
  );
};

export default UserDetails;
